





















import { Component, Prop, Vue } from 'vue-property-decorator';

export interface ConfirmOption {
    text: string
    action: () => void
}

@Component
export default class ConfirmDialog extends Vue {
    title?: string
    message?: string
    positive?: ConfirmOption
    negative?: ConfirmOption
    data() {
        return {
            title: null,
            message: null,
            positive: null,
            negative: null,
        }
    }
    show(title?: string, message?: string, positive?: ConfirmOption, negative?: ConfirmOption) {
        this.title = title
        this.message = message
        this.positive = positive
        this.negative = negative
        var el: any = $(this.$el)
        el.modal('show')
    }
    showMessage(message: string) {
        this.show(undefined, message)
    }
    onPositiveClick() {
        if (this.positive) {
            this.positive.action()
        }
    }
    onNegativeClick() {
        if (this.negative) {
            this.negative.action()
        }
    }
}
